import { format } from 'date-fns';
import { useIntl } from 'react-intl';

import Chip from 'src/componentes/chip';
import useAuth from 'src/hooks/useAuth';
import formatDateFns from 'src/utils/formatDateFns';
import { getDataAplicacaoFormularioGlobal } from 'src/paginas/avaliacao-desempenho/PesquisaClima/utils';

function EvolucaoFiltroChips({ filtro }) {
  const intl = useIntl();
  const { user } = useAuth();
  const { currentDisplay, currentLocale } = formatDateFns(user?.idioma, true);
  const formatarData = (value) =>
    format(value, currentDisplay, { locale: currentLocale });
  const formatarDataAplicacao = (value) => {
    const data = getDataAplicacaoFormularioGlobal(value);
    return data && !Number.isNaN(data.getTime()) ? formatarData(data) : '-';
  };
  const chips = [];

  if (filtro.dataInicio) {
    chips.push({
      key: 'dataInicio',
      label: `${intl.formatMessage({
        id: 'labelEvolucaoPeriodoInicio',
      })}: ${formatarData(filtro.dataInicio)}`,
    });
  }
  if (filtro.dataTermino) {
    chips.push({
      key: 'dataTermino',
      label: `${intl.formatMessage({
        id: 'labelEvolucaoPeriodoFim',
      })}: ${formatarData(filtro.dataTermino)}`,
    });
  }
  if (filtro.idsSelecionados?.length) {
    const titulo = intl.formatMessage({ id: 'labelEvolucaoUsosEspecificos' });
    const periodos = filtro.idsSelecionados.map((id) => {
      const aplicacao = filtro.aplicacoes.find(
        (item) => String(item.formularioUsoId) === id
      );
      if (!aplicacao) return `#${id}`;
      return intl.formatMessage(
        { id: 'labelPeriodoAplicacaoPesquisaClima' },
        {
          dataInicio: formatarDataAplicacao(aplicacao.dataInicio),
          dataTermino: formatarDataAplicacao(aplicacao.dataTermino),
        }
      );
    });
    const label = `${titulo}: ${
      periodos.length === 1 ? periodos[0] : intl.formatNumber(periodos.length)
    }`;
    chips.push({
      key: 'idsSelecionados',
      label,
      title: `${titulo}: ${periodos.join(', ')}`,
    });
  }

  if (!chips.length) return null;

  return (
    <div
      className="d-flex flex-wrap align-items-center mb-3"
      style={{ gap: 8 }}
    >
      {chips.map(({ key, label, title }) => (
        <Chip
          key={key}
          label={label}
          onDelete={() => filtro.onRemover(key)}
          title={title || label}
        />
      ))}
    </div>
  );
}

export default EvolucaoFiltroChips;
